export const TOKEN_KEY = 'auth.token';
export const USER_KEY = 'auth.user';

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

export const getUser = () => {
  const user = sessionStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};
export const setUser = (user) => sessionStorage.setItem(USER_KEY, JSON.stringify(user));
export const clearUser = () => sessionStorage.removeItem(USER_KEY);

// Role-based access control helpers
export const isAdmin = () => {
  const user = getUser();
  return user?.role === 'admin';
};

export const hasRole = (role) => {
  const user = getUser();
  return user?.role === role;
};

export const hasPermission = (permission) => {
  const user = getUser();
  if (!user) return false;
  // Admin has all permissions
  if (user.role === 'admin') return true;
  // Check if user has the specific permission
  return user.permissions?.includes(permission) || false;
};

export const hasAnyPermission = (permissions) => {
  const user = getUser();
  if (!user) return false;
  // Admin has all permissions
  if (user.role === 'admin') return true;
  // Check if user has any of the specified permissions
  return permissions?.some(permission => user.permissions?.includes(permission)) || false;
};
